import { useEffect, useState } from "react";

export const HorasUsoSelect = ({ name, value, onChange }) => {
  const [state, setState] = useState([]);

  // Cargar los meses del año
  const cargarArray = () => {
    return [
      { name: "Consolidado", value: 0 },
      { name: "100 horas", value: 100 },
      { name: "475 horas", value: 475 },
      { name: "850 horas", value: 850 },
      { name: "1225 horas", value: 1225 },
      { name: "1600 horas", value: 1600 },
      { name: "1975 horas", value: 1975 },
    ];
  };

  useEffect(() => {
    setState(cargarArray());
  }, [name]);

  if (state.length === 0) return <div>No data</div>;
  return (
    <select
      className="select-horas"
      name={name}
      value={value}
      onChange={onChange}
    >
      {/* <option value="99">Seleccionar...</option> */}
      {state.map((item) => (
        <option key={`horas-${item.value}`} value={item.value}>
          {item.name}
        </option>
      ))}
    </select>
  );
};
